import { gql } from '@apollo/client';

export const SMSSendGql = gql`
  query SMSSend($from: String!, $to: String!, $message: String!) {
    sendSMS(from: $from, to: $to, message: $message) {
      status
    }
  }
`;
